import Icon from 'veui/components/Icon'
import { IconHome } from 'dls-icons-vue'

Icon.register('home', IconHome)
